import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Row, Col, Panel, Button, ButtonToolbar } from 'react-bootstrap';
import PropTypes from 'prop-types';

import TypeRadios from '../../containers/Common/TypeRadios';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import { saveCategory2Products } from '../../actions/products_actions';
import SpinnerButton from '../Common/SpinnerButton';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';

const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');

const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

const propTypes = {
  category2Products: PropTypes.arrayOf(PropTypes.object),
  category2ProductsIsLoading: PropTypes.bool.isRequired,
  category2Id: PropTypes.number,
  dependentValues: PropTypes.shape({
    ProductNum: PropTypes.string,
  }),
  rowKey: PropTypes.string,
};

const defaultProps = {
  category2Products: [],
  dependentValues: {},
  category2Id: null,
  rowKey: 'Index',
};

class Category2Detail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortColumn: null,
      sortDirection: null,
      filters: {},
      rows: [],
      selectedRows: [],
      editedRows: [],

      suggestValue: '',
      productSearchType: 'ProductNum',
      selectedProduct: null,

      isLoadingSave: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.category2Products && nextProps.category2Products !== this.props.category2Products) {
      this.setState({ rows: nextProps.category2Products });
    }
  }

  onSuggestionSelected = (productNum, suggestions) => {
    this.setState({ selectedProduct: suggestions }, this.addProductToTable);
  }

  addProductToTable = () => {
    if (!this.props.category2Id) {
      alert('Please select a category.');
      return;
    }
    this.setState((prevState) => {
      const { rows, selectedProduct } = prevState;
      const index = _.findIndex(rows, { Product_id: selectedProduct.Product_id });
      if (index === -1) {
        if (isEcity) {
          rows.unshift(selectedProduct);
        } else {
          rows.push(selectedProduct);
        }
      } else {
        alert('Product is already in the list');
      }
      return { rows, selectedProduct: null, suggestValue: '' };
    });
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  removeRow = (ProductNum) => {
    let rows = [...this.state.rows];
    rows = rows.filter((obj) => {
      const match = String(obj.ProductNum) !== ProductNum;
      return match;
    });
    this.setState({ rows });
  }

  handleCategory2ProductsSave = () => {
    const { category2Id } = this.props;
    const { rows } = this.state;
    const products = _.map(rows, 'Product_id');
    
    const handleSuccess = () => {
      this.setState({ isLoadingSave: false });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingSave: false });
      alert(JSON.stringify(error));
    };
    
    this.setState({ isLoadingSave: true }, () => {
      saveCategory2Products(products, category2Id, handleSuccess, handleFailure);
    });
  }

  renderAutoSuggest() {
    return (
        <GenericProductSuggest
          value={this.state.suggestValue}
          onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
          SearchType={this.state.productSearchType}
          fetchOrdersByProduct={this.onSuggestionSelected}
        />
    );
  }

  renderTable() {
    const that = this;
    if (this.props.category2ProductsIsLoading) {
      return <Spinner />;
    }
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const handleFilterChange = (filter) => {
      let newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const state = { ...this.state, filters: newFilters };
      this.setState(state);
    }

    const onClearFilters = () => {
      // all filters removed
      const state = { ...this.state, filters: {} };
      this.setState(state);
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      this.setState({ sortColumn: null, sortDirection: null });
      const rows = getRows();
      const editedRows = this.state.editedRows.slice(0);
      Object.assign(rows[e.rowIdx], e.updated);
      // if the element is already edited, remove the old one.
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Idx) {
          editedRows.splice(index, 1);
        }
      }, this);
      // push the row into the editedRows array
      editedRows.push(rows[e.rowIdx]);
      this.setState({ rows, editedRows });
    };

    const isDraggedRowSelected = (selectedRows, rowDragSource) => {
      if (selectedRows && selectedRows.length > 0) {
        const key = this.props.rowKey;
        return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
      }
      return false;
    };

    const reorderRows = (e) => {
      const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.rows });
      const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
      const undraggedRows = this.state.rows.filter(r => draggedRows.indexOf(r) === -1);
      const args = [e.rowTarget.idx, 0].concat(draggedRows);
      Array.prototype.splice.apply(undraggedRows, args);
      undraggedRows.map((row, index) => {
        row.Index = index;
      });
      this.setState({ rows: undraggedRows });
    };

    const IsVariableFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                const { ProductNum } = this.props.dependentValues;
                that.removeRow(ProductNum);
              }}
            >
              X
            </Button>
          </span>
        );
      },
    });

    const columns = [
      {
        name: <Translate value="del" />,
        width: 50,
        formatter: IsVariableFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      ...(isAFM ? [{
        key: 'Brand',
        name: <Translate value="brand" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      }] : []),
      {
        key: 'RefNum',
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: 'in_stock',
        name: <Translate value="inventory" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: false,
        filterable: true,
        width: 250,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: false,
        filterable: true,
        width: 250,
      },
    ];

    // if (this.state.rows && this.state.rows.length > 0) {
    //   this.state.rows.map((r) => {
    //     r.RefNum = Number(r.RefNum);
    //   });
    // }

    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: '99%' }} id="Category2Detail-dataGrid1">
            <DraggableContainer>
              <ReactDataGrid
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                toolbar={<Toolbar enableFilter={true} />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                minHeight={570}
                rowHeight={25}
                enableRowSelect="single"
                rowActionsCell={RowActionsCell}
                rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
                onRowUpdated={handleRowUpdated}
              />
            </DraggableContainer>
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <Panel id="category2-detail">
        <ContentWrapper>
          <h2><Translate value="category_2_product_list" /></h2>
          <Panel id="search-panel">
            <Col xs={12} className="search-panel-left text-nowrap">
              <div id="autosuggest-div">
                <Row style={{ height: '30px' }}>
                  <Col xs={12}>
                    <TypeRadios
                      value={this.state.productSearchType}
                      handleOptionChange={this.handleOptionChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    { this.renderAutoSuggest() }
                  </Col>
                </Row>
              </div>
            </Col>
          </Panel>
          <ButtonToolbar style={{position: 'absolute', zIndex: 3}}>
            <SpinnerButton
              bsStyle="success"
              onClick={this.handleCategory2ProductsSave}
              disabled={this.state.isLoadingSave}
              loading={this.state.isLoadingSave}
              icon="fa-save"
              translation={<Translate value="save" />}
            />
          </ButtonToolbar>
          {this.renderTable()}
        </ContentWrapper>
      </Panel>
    );
  }
}

Category2Detail.propTypes = propTypes;
Category2Detail.defaultProps = defaultProps;

export default Category2Detail;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/Category2Detail.jsx